//#region LOCAL STORAGE
/**
 Almacena en el Storage el _Json pasado como parametro, con la _Key pasada como parametro.
La misma funcion se encarga de aplicarle el Stringify al _Json.
Retorna Verdadero cuando logra guardar, y Falso cuando no puede guardar. Ademas en este ultimo caso
limpia el storage.
 */
module.exports.GuardarJsonEnStorage = (_Key, _Json) => {
  var _Retorno = false;
  //Guardo el JSON
  try {
    localStorage.setItem(_Key, JSON.stringify(_Json));
    _Retorno = true;
  } catch (e) {
    console.log(e);
    localStorage.clear();
  }
  return _Retorno;
};

/**
  Retorna un _Json guardado con la _Key pasada como paramtro.
  Si no lo encuentra, devuelve NULO.
  */
module.exports.RecuperarJsonDeStorage = (_Key) => {
  var _Retorno = null;
  try {
    _Retorno = JSON.parse(localStorage.getItem(_Key));
  } catch (e) {
    console.log(e);
  }
  return _Retorno;
};

/**
  Retorna un array de _Json guardados con parte del nombre de la Key pasada como paramtro.
  Si no encuentra nada devuelve vacío.
  */
module.exports.RecuperarJsonsDeStorage = (_PalabraConQueArranca) => {
  var _Retorno = [];
  try {
    for (var key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        if (key.includes(_PalabraConQueArranca)) {
          _Retorno.push(this.RecuperarJsonDeStorage(key));
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
  return _Retorno;
};
/**
 * Retorna NULO si no logra recuperar nada.
 */
module.exports.RecuperarProgresoDeStorage = () => {
  var _Retorno = null;
  try {
    for (var key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        if (key.includes(ProgresoUsuario._PreKey)) {
          _Retorno = JSON.parse(localStorage.getItem(key));
          break;
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
  return _Retorno;
};
module.exports.EliminarJsonDelStorage = (_KeyAEliminar) => {
  try {
    localStorage.removeItem(_KeyAEliminar);
    console.log(_KeyAEliminar + " eliminado del Storage!");
  } catch (e) {
    console.log(e);
  }
};
module.exports.EliminarJsonDelStorage1 = (_PalabraConQueArranca) => {
  try {
    for (var key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        if (key.includes(_PalabraConQueArranca)) {
          EliminarJsonDelStorage(key);
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
};
module.exports.LimpiarStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.log(error);
  }
};
/**
  Retorna el tamaño en KB.
  */
module.exports.TamañoUsadoPorElStorage = () => {
  var _Retorno = 0;
  try {
    var allStrings = "";
    for (var key in window.localStorage) {
      //console.log(key);
      if (window.localStorage.hasOwnProperty(key)) {
        allStrings += window.localStorage[key];
      }
    }
    _Retorno = allStrings ? (allStrings.length * 16) / (8 * 1024) : 0;
  } catch (e) {
    console.log(e);
  }
  return _Retorno;
};
//#endregion